import script from "./PharmacyComissionPrintForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PharmacyComissionPrintForm.vue?vue&type=script&setup=true&lang=js"

import "./PharmacyComissionPrintForm.vue?vue&type=style&index=0&id=3fa303de&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa303de"]])

export default __exports__